// extracted by mini-css-extract-plugin
export default {"detailsContainer":"DetailBenefactorInformation_detailsContainer__Chojp","statusContainer":"DetailBenefactorInformation_statusContainer__GHURQ"};